import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';

export interface BrowserInfo {
  isIOS: boolean;
  isIOSWebView: boolean;
  isAndroidWebView: boolean;
  isFacebook: boolean;
  isLine: boolean;
  isWeChat: boolean;
  isInApp: boolean;
  isInChottoApp: boolean;
  userAgent: string;
}

export const getBrowserInfo = async (): Promise<BrowserInfo> => {
  if (typeof window === 'undefined') {
    return {
      isIOS: false,
      isIOSWebView: false,
      isAndroidWebView: false,
      isFacebook: false,
      isLine: false,
      isWeChat: false,
      isInApp: false,
      isInChottoApp: false,
      userAgent: '',
    };
  }

  const ua = navigator.userAgent || '';
  const isIOS = (/iPhone|iPad|iPod/.test(ua));
  const isIOSWebView = isIOS && (!/Safari/.test(ua));
  const isAndroidWebView = (/Android/.test(ua) && /wv/.test(ua));
  const isFacebook = /FBAN|FBAV|FB_IAB|FB4A|Instagram/.test(ua);
  const isLine = /Line/.test(ua);
  const isWeChat = /MicroMessenger/.test(ua);
  const isInApp = isIOSWebView || isAndroidWebView || isFacebook || isLine || isWeChat;
  const inChottoApp = await isInChottoApp();

  return {
    isIOS,
    isIOSWebView,
    isAndroidWebView,
    isFacebook,
    isLine,
    isWeChat,
    isInApp,
    isInChottoApp: inChottoApp,
    userAgent: ua,
  };
};

const isInChottoApp = async (): Promise<boolean> => {
  const isCapacitor = Capacitor.isNativePlatform();
  if (!isCapacitor) return false;
  try {
    const info = await CapApp.getInfo();
    return info.id === 'com.gmonsters.chottotest2';
  } catch (err) {
    console.error("Failed to get App info", err);
    return false;
  }
};

let _isInChottoAppCached: boolean | null = null;

export const initChottoAppDetection = async (): Promise<boolean> => {
  _isInChottoAppCached = await isInChottoApp();
  return _isInChottoAppCached;
};

export const isInChottoAppSync = (): boolean => {
  if (_isInChottoAppCached === null) {
    console.warn('isInChottoAppSync called before initChottoAppDetection');
    return false;
  }
  return _isInChottoAppCached;
};
